import { Link } from "react-router-dom"
import { Badge } from "@/components/ui/badge"
import { Card, CardContent } from "@/components/ui/card"
import type { NavItem } from "@/components/layout/nav-types"

interface Props {
  item: NavItem
}

export function QuickAccessTile({ item }: Props) {
  const Icon = item.icon

  return (
    <Link
      to={item.path}
      className="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-xl"
    >
      <Card className="h-full transition-colors group-hover:bg-accent/50">
        <CardContent className="flex h-full flex-col gap-3">
          <div className="flex items-center justify-between">
            <div className="rounded-md bg-muted p-2 text-foreground">
              <Icon className="size-5" />
            </div>
            {!item.enabled && (
              <Badge variant="secondary" className="text-[10px] uppercase">
                wkrótce
              </Badge>
            )}
          </div>
          <div className="space-y-1">
            <p className="font-medium leading-none">{item.label}</p>
            <p className="text-xs text-muted-foreground">{item.description}</p>
          </div>
        </CardContent>
      </Card>
    </Link>
  )
}
